export default __webpack_public_path__ + "static/media/ctxc.4e3dfce7.svg";